@if (options) {
  <highcharts-chart
    [options]="options"
    (chartInstance)="onChartInstance($event)"
  />
}
